import Component from './interior';

export default Component;